import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-[9px] py-[3px] text-[11px] font-semibold',
  {
    variants: {
      variant: {
        default: 'bg-chip text-fg-soft',
        primary: 'bg-primary-tint text-primary-dark',
        success: 'bg-success-bg text-success-fg',
        danger: 'bg-danger-bg text-danger',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
